export enum InputEnum {
  EMAIL = "email",
  PASSWORD = "password",
}
